import { Page } from 'layouts/Page';
import { FC } from 'react';
import { VATReport } from 'components/VATReport-old';
import { IS_NEMAN } from '../../services/constants/env';

export const VATReportPage: FC = () => {
	return (
		<Page title={`VAT Report – ${IS_NEMAN ? ' Neman IOSS' : 'EAS'} Control Center`}>
			<VATReport />
		</Page>
	);
};
